import { useAuth, useFeature } from '../../context/AuthContext';
import Dashboard from '../Dashboard';
import HomePage from './HomePage';

/**
 * home_dashboard on (default) => new home; off => the classic My tools page,
 * untouched. Until the flag map has loaded, render neither: flags fail open,
 * so guessing would mount HomePage (and fire its requests) for an org that
 * turned it off, then swap to Dashboard. `featuresLoaded` is only false
 * inside the real provider; test providers that omit it count as loaded.
 */
export default function HomeRoute() {
  const { featuresLoaded } = useAuth() || {};
  const homeOn = useFeature('home_dashboard');
  if (featuresLoaded === false) {
    return (
      <div className="state-panel" role="status">
        <div className="spinner" />
        <span className="sr-only">Loading…</span>
      </div>
    );
  }
  return homeOn ? <HomePage /> : <Dashboard />;
}
